module.exports = __webpack_public_path__ + "static/service-icon5-1b9ffcf7dbfb50f60a9b3e838efc265a.png";